import React from 'react';
import Icon from '../../../components/AppIcon';

const StudentCard = ({ student, isSelected, onClick }) => {
  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - activityTime) / (1000 * 60));
    
    if (diffInMinutes < 60) return `Il y a ${diffInMinutes} min`;
    if (diffInMinutes < 1440) return `Il y a ${Math.floor(diffInMinutes / 60)} h`;
    return `Il y a ${Math.floor(diffInMinutes / 1440)} j`;
  };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left p-4 rounded-lg border-2 transition-all duration-250 ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-md'
          : 'border-border bg-card hover:border-primary/50 hover:shadow-sm'
      }`}
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-semibold text-lg flex-shrink-0">
          {student?.avatar}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1 truncate">
            {student?.name}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">{student?.currentGrade}</p>
        </div>
        {isSelected && (
          <div className="flex-shrink-0">
            <Icon name="CheckCircle2" size={20} className="text-primary" />
          </div>
        )}
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between text-xs md:text-sm">
          <span className="text-muted-foreground">{student?.level}</span>
          <span className="font-medium text-primary">{student?.progressPercentage}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full transition-all duration-500"
            style={{ width: `${student?.progressPercentage}%` }}
          />
        </div>
        <div className="flex items-start gap-2 pt-2 border-t border-border">
          <Icon name="Activity" size={14} className="text-muted-foreground mt-0.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground line-clamp-2">{student?.recentActivity}</p>
            <p className="text-xs text-muted-foreground mt-1">{formatTimeAgo(student?.lastActive)}</p>
          </div>
        </div>
      </div>
    </button>
  );
};

export default StudentCard;